export default "__VITE_ASSET__C9TY_kkl__"